export enum ProductCategoriesEnum {
  PARFUMERIA = 'parfumeria',
  KOSMETIKA = 'kosmetika'
}
